import {
  DestroyRef,
  Directive,
  Input,
  OnChanges,
  OnInit,
  inject,
  SimpleChanges,
  ComponentRef,
} from '@angular/core';

import { toggleCssClass } from '@recruitee/common';

import { IconComponent, IconSize } from '../../../icon/icon.component';
import { setInputs } from '../../button.types';
import { ButtonComponent } from '../../components/button/button.component';

@Directive({
  standalone: true,
  selector: 'rt-button[dropdownOpened], a[rt-button][dropdownOpened]',
})
export class ButtonDropdownIndicatorDirective implements OnChanges, OnInit {
  @Input() public dropdownOpened: boolean = false;
  @Input() public dropdownVisible: boolean = true;
  @Input() public dropdownIconSize: IconSize = 'small';

  private buttonCmp = inject(ButtonComponent);
  private destroyRef = inject(DestroyRef);
  private iconComponentRef: ComponentRef<IconComponent>;

  private buttonStateClassToggles = [
    toggleCssClass('dropdown-indicator', () => this.dropdownVisible),
    toggleCssClass('dropdown-indicator-hidden', () => !this.dropdownVisible),
    toggleCssClass('dropdown-open', () => this.dropdownOpened),
    toggleCssClass('pressed', () => this.dropdownOpened),
  ];

  public ngOnChanges(changes: SimpleChanges): void {
    this.buttonStateClassToggles.forEach(toggle => toggle.toggleIfCondition());

    if (changes.dropdownIconSize && this.iconComponentRef) {
      this.updateIconInputs();
    }
  }

  public ngOnInit() {
    this.iconComponentRef = this.buttonCmp.suffix.createComponent(IconComponent);
    this.updateIconInputs();
    this.destroyRef.onDestroy(() => this.iconComponentRef.destroy());
  }

  private updateIconInputs() {
    setInputs(this.iconComponentRef, {
      name: 'arrow-drop-down',
      size: this.dropdownIconSize,
    });
  }
}
